import styled, { keyframes } from 'styled-components';
import ChatBubble from './ChatBubble';
import { UserAvatar } from '@vs-online-only-app/ui';
import { FC } from 'react';
import { useSelectedHeroConversation } from '../../hooks/useSelectedHeroConversation';

const animationKeyframes = keyframes`
  0% { background-position: 30px }
  100% { background-position: 0px }
`;

export const StyledTyping = styled.div`
  width: 30px;
  height: 6px;
  animation: ${animationKeyframes} 1.5s infinite linear;
  background-image: url('assets/IconTypingIndicator.svg');
  margin: 6px 0;
`;

const GridWrapper = styled.div`
  display: grid;
  grid-template-columns: ${({ theme }) => theme.spacing(4)} 1fr;
  column-gap: ${({ theme }) => theme.spacing(1)};
`;

const TypingMessage: FC = () => {
  const heroConversation = useSelectedHeroConversation();
  const fallbackCharacter = heroConversation?.conversationStarter?.firstName
    .charAt(0)
    .toUpperCase();

  return (
    <GridWrapper>
      <UserAvatar fallbackCharacter={fallbackCharacter} color="#E95D11" />
      <ChatBubble direction="left" backgroundColor="secondary">
        <StyledTyping />
      </ChatBubble>
    </GridWrapper>
  );
};

export default TypingMessage;
